import React from 'react';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaLocaleProvider, WeaTools} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import OpToolbar from '../common/OpToolbar';
import TitleTabPane from '../common/TitleTabPane';
import { doPrev, doNext, handleWidth } from '../../util/common';
//tab的标题组件
class Title extends React.Component {
    componentDidMount() {
        const { config, tabids } = this.props;
        const { eid, header } = config.item;
        this.setMoreHref();
        handleWidth(eid,config.params.hpid,tabids.length,header.canHeadbar, header.displayPosition);
    }
    componentDidUpdate() {
        const { config, tabids } = this.props;
        const { eid, header } = config.item;
        this.setMoreHref();
        handleWidth(eid,config.params.hpid,tabids.length,header.canHeadbar, header.displayPosition);
    }
    shouldComponentUpdate(nextProps){
        return !isEqual(this.props, nextProps)
    }

    setMoreHref() {
        const { config, eMoreShowType, eMoreAddress, currentTab } = this.props;
        const { eid } = config.item;
        window.elements_more_params[eid] = {isRouteUrl: true, eMoreShowType: eMoreShowType, eMoreAddress: eMoreAddress, tabid: currentTab};
    }

    render() {
        const tdStyle={width: this.props.tabwidth + 'px', paddingTop: '5px', verticalAlign: 'top',backgroundSize: '100% 100%', height: '32px',marginTop: '-8px'};
        const tdStyle1={width: 'auto', marginRight: '10px', paddingTop: '5px', verticalAlign: 'top',backgroundSize: '100% 100%', height: '32px',marginTop: '-7px'};
        const { currentTab, config, tabids = [], titles = [], handleRefresh, handleDelete, handleTabData, fontSizeMp, isAlwaysShow } = this.props;
        const { eid, ebaseid } = config.params;
        const { header } = config.item;
        let { fontStyle = {} } = config.item;
        if(!isEmpty(fontSizeMp)){
            fontStyle = fontSizeMp;
        }
        let className = tabids.length <= 1 && isAlwaysShow == '0' ? 'nodisplay' : '';
        if(header.displayPosition && header.displayPosition == 'bottom'){
            return <div id={ `titleContainer_${eid}` } className={`titlecontainer ${className}`}>
                <TitleTabPane ecId={`${this && this.props && this.props.ecId || ''}_TitleTabPane@mwqt93`} datas={this.props} fontStyle={fontStyle} tdStyle={tdStyle} tdStyle1={tdStyle1} ebaseid={ebaseid}/>
                {!config.item.header.canHeadbar ? <OpToolbar ecId={`${this && this.props && this.props.ecId || ''}_OpToolbar@lx6s3n`} config={config} clsname={className} handleRefresh={handleRefresh} handleDelete={handleDelete}/> : ''}
            </div>
        }else {
            return <div/>
        }
      }
}
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg=this.props.error && this.props.error !=="";
            return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@v9vcc2`} msg={ hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") } />
        );
    }
}
Title = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(Title);
export default Title;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/rss/Title.js